import { PusherClient } from '@getaccept/pusher';
import { getPrefixedInternalApiBaseUrl } from '../helpers/get-prefixed-api-base-url';
import { UrlHelper } from '../helpers/url.helper';

export const pusherClientInternal = new PusherClient(
  UrlHelper.getHttpsUrl(
    getPrefixedInternalApiBaseUrl(
      process.env.VUE_APP_INTERNAL_API_BASE_URL,
      window.location.hostname
    )
  )
);
